export const baseUrl = "https://irtaah.thedevora.tech/api";

export const loginURL = "v1/login";

export const governoratesURL = "v1/governorates";

export const areasURL = "v1/areas";

export const servicesURL = "v1/services";

export const appointmentsURL = "v1/appointments";

export const categoriesURL = "v1/categories";

export const clientsURL = "clients/";

export const clientURL = "clients";

export const usersURL = "v1/users";

export const permissionsURL = "permissions";

export const notificationsURL = "v1/notifications";

export const statisticsURL = "statistics";

export const departmentsURL = "departments";

export const contactUsURL = "v1/contact-us";
